module.exports = __webpack_public_path__ + "media/images/svg/arrow-down-2576f08e2263aec47aaf7278c938d8ee.svg";